import { render, staticRenderFns } from "./AdminPanelShoppingPacket.vue?vue&type=template&id=3776547c&"
import script from "./AdminPanelShoppingPacket.vue?vue&type=script&lang=js&"
export * from "./AdminPanelShoppingPacket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports